<template>
  <div class="desk-wrapper" style="display: flex; flex-direction: column">
    <div class="common-box">
      <div class="common-title">工作台</div>
      <div class="desk-info-container">
        <div class="info">
          <el-avatar
            :size="72"
            :src="userInfo.avatar"
            fit="contain"
          ></el-avatar>
          <div class="ml20">
            <div class="name mb10">
              早安，{{ userInfo.user_name }}，祝你开心每一天！
            </div>
            <div class="c9">{{ deptName }}</div>
          </div>
        </div>
        <div class="num-container">
          <div class="item">
            <div class="c9 mb5">呼叫订单数</div>
            <div class="num-family">56</div>
          </div>
          <div class="item">
            <div class="c9 mb5">排名</div>
            <div class="num-family">8/10</div>
          </div>
          <div class="item">
            <div class="c9 mb5">完成</div>
            <div class="num-family">9</div>
          </div>
        </div>
      </div>
    </div>
    <el-row type="flex" :gutter="10" class="mt10 flex-one">
      <el-col :span="16" class="flex-vertic">
        <deskOrder :title="true"></deskOrder>
        <div class="common-box mt10 flex-one flex-vertic">
          <div class="o-title border">动态</div>
          <div class="flex-one" v-if="dynamicList.length > 0">
            <div
              class="info-list-item border flex c9"
              v-for="item in 4"
              :key="item"
            >
              <el-avatar :size="40" src="/img/bg/imh.png"></el-avatar>
              <div class="flex-one ovh ml10">
                <div class="ovh c3">
                  user 接收并确认了帮扶计划（张三+心理辅导）
                </div>
                <div>11天前</div>
              </div>
            </div>
            <div class="tar mt10">
              <el-pagination
                @current-change="handleCurrentChange"
                :current-page="page1.current"
                layout="prev, pager, next"
                :total="page1.total"
              >
              </el-pagination>
            </div>
          </div>
          <div v-if="dynamicList.length == 0" class="flex-one flex-v-c">
            <div class="empty-img"></div>
            <div class="c6">暂无数据</div>
          </div>
        </div>
      </el-col>
      <el-col :span="8" class="flex-vertic">
        <div class="common-box">
          <div class="o-title border">快速开始 / 便捷导航</div>
          <div>
            <el-button type="text" @click="$router.push('/order/index')"
              >案件中心</el-button
            >
            <el-button type="text" @click="$router.push('/archives/index')"
              >档案中心</el-button
            >
            <el-button type="text" @click="$router.push('/notice/index')"
              >消息通知</el-button
            >
            <!-- <el-link class="mr15 mt5 mb5" :underline="false">案件中心</el-link>
                        <el-link class="mr15 mt5 mb5" :underline="false">消息通知</el-link>
                        <el-link class="mr15 mt5 mb5" :underline="false">档案中心</el-link> -->
            <!-- <el-button type="primary" icon="el-icon-plus" plain class="mt5 mb5">主要按钮</el-button> -->
          </div>
        </div>
        <div class="common-box mt10 flex-one">
          <div class="o-title flex border">
            工作信息<el-link
              :underline="false"
              @click="$router.push('/job/jobinformationList')"
              >更多</el-link
            >
          </div>
          <div
            class="info-list-item flex c9"
            v-for="item in infoList"
            :key="item.id"
            @click="seeDetailHandle(item)"
          >
            <!-- <el-avatar :size="24" src="/img/bg/imh.png"></el-avatar> -->
            <div class="flex-one ovh ml10">
              <span class="ovh">{{ item.title }}</span>
            </div>
            <div>{{ item.createTime }}</div>
          </div>
        </div>
        <!-- <div class="common-box mt10 flex-one">
                    <div class="o-title border">统计信息</div>
                    <div class="tar">
                        <el-radio-group v-model="radio4" class="radio-checkbox" size="mini">
                            <el-radio-button label="机构帮扶对象统计"></el-radio-button>
                            <el-radio-button label="按年龄"></el-radio-button>
                            <el-radio-button label="按帮扶类型"></el-radio-button>
                        </el-radio-group>
                    </div>
                    <div class="pie-chart">
                        <pie1></pie1>
                    </div>
                </div> -->
      </el-col>
    </el-row>
    <el-dialog
      title="订单详情"
      append-to-body
      width="80%"
      :visible.sync="orderDetailVisible"
      custom-class="common-dialog"
    >
      <orderDetail
        :detail="detailInfo"
        :initOrderId="initOrderId"
        :isOpt="isMode == 2"
        :isShenHe="isMode == 3"
        :printBtn="true"
        @close="
          orderDetailVisible = false;
          refreshChange();
        "
      >
      </orderDetail>
    </el-dialog>
    <el-dialog
      title="工作信息详情"
      fullscreen
      append-to-body
      width="80%"
      :visible.sync="infoDetailVisible"
    >
      <see :info="detail"></see>
    </el-dialog>
  </div>
</template>
<script>
import pie1 from "@/components/chart/pie1.vue";
import deskOrder from "./components/desk-order.vue";
import { starorderconfirmrecordList } from "@/api/desk/index";
import { getPublishListDept } from "@/api/order/index";
import { getList } from "@/api/job/jobinformation";
import { mapGetters } from "vuex";
import { getDetail } from "@/api/job/jobinformation";
import see from "@/views/job/see.vue";
export default {
  components: {
    pie1,
    deskOrder,
    see,
  },
  data() {
    return {
      infoDetailVisible: false,
      detail: {},
      radio4: "最新更新",
      infoList: [],
      page1: {
        current: 1,
        size: 10,
        total: 0,
      },
      deptName: "",
      dynamicList: [],
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      getPublishListDept().then((res) => {
        let dept = res.data.data.find((v) => v.id == this.userInfo.dept_id);
        this.deptName = dept.deptName;
      });
      starorderconfirmrecordList(this.page1.current, this.page1.size).then(
        (res) => {
          this.dynamicList = this.dynamicList.concat(res.data.data.records);
          this.page1.total = res.data.data.total;
        }
      );
      getList(1, 10).then((res) => {
        const data = res.data.data;
        this.infoList = data.records;
      });
    },
    handleCurrentChange(val) {
      this.page1.current = val;
      this.load();
    },
    seeDetailHandle(row) {
      getDetail(row.id).then((res) => {
        this.detail = res.data.data;
        this.infoDetailVisible = true;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/moudles/desk.scss";
</style>
<style lang="scss">
.desk-wrapper {
  .avue-crud__menu {
    display: none;
  }
  .el-avatar {
    background-color: #fff;
  }
}
</style>
